import React, { useContext, useEffect, useRef, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  Navigate,
} from "react-router-dom";

import Navbar from "./components/Navbar";
import NavbarScroll from "./components/Navbar/NavbarScroll";
import WhatsAppIcon from "./components/WhatsAppIcon";
import Scroll from "./components/Scroll";
import Footer from "./components/Footer";
import { AppContext } from "./context/AppContext";

import LoginPage from "./login/LoginPage";
import Register from "./login/Usuario/Register";
import UpdatePasswordPage from "./login/Usuario/UpdatePasswordPage";
import UpdatePassworSystem from "./login/UpdatePasswordPage";

import HomePage from "./pages/HomePage";
import AboutUs from "./pages/AboutUsPage";
import CategoriesPage from "./pages/CategoriesPage";
import ServicesSPage from "./pages/ServicePage";
import ContactPage from "./pages/ContactPage";
import ProductDetail from "./components/Categories/ProductDetail";
import ShopPage from "./pages/ShopPage";
import ProductPage from "./pages/ProductPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsAndConditionsPage from "./pages/TermsAndConditionsPage";
import OfferPage from "./pages/OfferPage";

import UserPanel from "./login/Usuario/UserPanel";
import AdminPanel from "./login/Administrador/AdminPanel";
import EnterprisePanel from "./login/Empresa/EnterprisePanel";
import NewInvoice from "./login/Empresa/NuevaFactura/NewInvoice";
import Checkout from "./pages/Checkout";
import CheckoutSuccess from "./pages/CheckoutSuccess";

import AdminSection from "./login/Administrador/AdminSection";
import Section from "./login/Administrador/Section";
import AdminProduct from "./login/Administrador/AdminProduct";
import Product from "./login/Administrador/Product";
import ProductDashboard from "./login/Administrador/ProductForm/ProductDashboard";
import Warehouses from "./login/Administrador/ProductForm/Warehouses";
import AdminProforma from "./login/Administrador/AdminProforma";
import Proforma from "./login/Administrador/Proforma";
import AdminClient from "./login/Administrador/AdminClient";
import Client from "./login/Administrador/Client";
import ClientDetail from "./login/Administrador/ClientForm/ClientDetail";
import AdminVariant from "./login/Administrador/AdminVariant";
import Variant from "./login/Administrador/Variant";
import AdminPromotion from "./login/Administrador/AdminPromotion";
import Promotion from "./login/Administrador/Promotion";
import AdminServices from "./login/Administrador/AdminServices";
import Services from "./login/Administrador/Services";
import AdminInvoice from "./login/Administrador/AdminInvoice";
import Invoice from "./login/Administrador/Invoice";
import RegisterPurchase from "./login/Administrador/RegisterPurchase";
import AdminAccounts from "./login/Administrador/AdminAccounts";
import DailyBook from "./login/Administrador/AccountsForm/DailyBook";
import AdminMotion from "./login/Administrador/AdminMotion";
import Motion from "./login/Administrador/Motion";
import MotionDetail from "./login/Administrador/MotionForm/MotionDetail";
import AdminBank from "./login/Administrador/AdminBank";
import Bank from "./login/Administrador/Bank";
import Payment from "./login/Administrador/Payment/Payment";
import ProformaFacturacion from "./login/Administrador/ProformaForm/ProformaFacturacion";
import AdminEcommerce from "./login/Administrador/AdminEcommerce";
import Ecommerce from "./login/Administrador/Ecommerce";
import AdminStatistics from "./login/Administrador/AdminStatistics";

const ProtectedRoute = ({ children, accountType }) => {
  const { user, authLoading } = useContext(AppContext);

  if (authLoading) {
    return null;
  }

  if (!user?.isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  if (accountType === "admin" && user.accountType !== "admin") {
    return <Navigate to="/user-panel" replace />;
  }

  if (accountType === "client" && user.accountType !== "client") {
    return <Navigate to="/admin-panel" replace />;
  }

  return children;
};

const AppLayout = ({ children }) => {
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const lastState = useRef(false);

  const isAuthOrAdmin =
    location.pathname === "/login" ||
    location.pathname === "/system/update-password" ||
    location.pathname.startsWith("/admin-panel");

  useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY;
      if (!lastState.current && y > 160) {
        lastState.current = true;
        setScrolled(true);
      } else if (lastState.current && y < 80) {
        lastState.current = false;
        setScrolled(false);
      }
    };

    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {!isAuthOrAdmin && (
        <>
          <div
            style={{
              opacity: scrolled ? 0 : 1,
              pointerEvents: scrolled ? "none" : "auto",
              transition: "opacity .28s ease",
            }}
          >
            <Navbar />
          </div>

          <div
            style={{
              position: "fixed",
              top: 8,
              left: "50%",
              transform: "translateX(-50%)",
              width: "90%",
              zIndex: 1200,
              opacity: scrolled ? 1 : 0,
              pointerEvents: scrolled ? "auto" : "none",
              transition: "opacity .28s ease",
            }}
          >
            <NavbarScroll />
          </div>
        </>
      )}

      <main style={{ flex: 1 }}>{children}</main>

      {!isAuthOrAdmin && <WhatsAppIcon />}
      {!isAuthOrAdmin && <Scroll />}
      {!isAuthOrAdmin && <Footer />}
    </div>
  );
};

const App = () => {
  return (
    <Router>
      <AppLayout>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/registro" element={<Register />} />
          <Route path="/actualizar-clave" element={<UpdatePasswordPage />} />
          <Route path="/system/update-password" element={<UpdatePassworSystem />} />

          <Route path="/" element={<HomePage />} />
          <Route path="/acerca-de-nosotros" element={<AboutUs />} />
          <Route path="/categorias" element={<CategoriesPage />} />
          <Route path="/servicios" element={<ServicesSPage />} />
          <Route path="/contacto" element={<ContactPage />} />
          <Route path="/categorias/:sectionSlug/:categorySlug" element={<CategoriesPage />} />
          <Route path="/categorias/:sectionSlug/:categorySlug/:productSlug" element={<ProductDetail />} />
          <Route path="/categorias/:sectionSlug/:categorySlug/:productSlug/:variantSlug" element={<ProductDetail />} />
          <Route path="/shop" element={<ShopPage />} />
          <Route path="/ofertas" element={<OfferPage />} />
          <Route path="/buscar" element={<ProductPage />} />
          <Route path="/politicas-privacidad" element={<PrivacyPolicyPage />} />
          <Route path="/terminos-condiciones" element={<TermsAndConditionsPage />} />

          <Route path="/user-panel" element={<ProtectedRoute accountType="client"><UserPanel /></ProtectedRoute>} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/checkout/exito" element={<CheckoutSuccess />} />

          <Route path="/admin-panel" element={<ProtectedRoute accountType="admin"><AdminPanel /></ProtectedRoute>} />
          <Route path="/admin-panel/*" element={<ProtectedRoute accountType="admin"><AdminPanel /></ProtectedRoute>} />
          <Route path="/admin-panel/empresa" element={<ProtectedRoute accountType="admin"><EnterprisePanel /></ProtectedRoute>} />

          <Route path="/admin-panel/secciones" element={<ProtectedRoute accountType="admin"><AdminSection /></ProtectedRoute>} />
          <Route path="/admin-panel/secciones/nueva" element={<ProtectedRoute accountType="admin"><Section /></ProtectedRoute>} />

          <Route path="/admin-panel/inventario/productos" element={<ProtectedRoute accountType="admin"><AdminProduct /></ProtectedRoute>} />
          <Route path="/admin-panel/inventario/productos/nuevo" element={<ProtectedRoute accountType="admin"><Product /></ProtectedRoute>} />
          <Route path="/admin-panel/inventario/productos/:id" element={<ProtectedRoute accountType="admin"><ProductDashboard /></ProtectedRoute>} />
          <Route path="/admin-panel/inventario/bodegas" element={<ProtectedRoute accountType="admin"><Warehouses /></ProtectedRoute>} />

          <Route path="/admin-panel/proformas" element={<ProtectedRoute accountType="admin"><AdminProforma /></ProtectedRoute>} />
          <Route path="/admin-panel/proformas/nueva" element={<ProtectedRoute accountType="admin"><Proforma /></ProtectedRoute>} />
          <Route path="/admin-panel/proformas/editar/:id" element={<ProtectedRoute accountType="admin"><Proforma /></ProtectedRoute>} />
          <Route path="/admin-panel/proformas/facturacion/:id" element={<ProtectedRoute accountType="admin"><ProformaFacturacion /></ProtectedRoute>} />

          <Route path="/admin-panel/servicios" element={<ProtectedRoute accountType="admin"><AdminServices /></ProtectedRoute>} />
          <Route path="/admin-panel/servicios/nuevo" element={<ProtectedRoute accountType="admin"><Services /></ProtectedRoute>} />

          <Route path="/admin-panel/clientes" element={<ProtectedRoute accountType="admin"><AdminClient /></ProtectedRoute>} />
          <Route path="/admin-panel/clientes/nuevo" element={<ProtectedRoute accountType="admin"><Client /></ProtectedRoute>} />
          <Route path="/admin-panel/clientes/:id" element={<ProtectedRoute accountType="admin"><ClientDetail /></ProtectedRoute>} />

          <Route path="/admin-panel/inventario/variantes" element={<ProtectedRoute accountType="admin"><AdminVariant /></ProtectedRoute>} />
          <Route path="/admin-panel/inventario/variantes/nueva" element={<ProtectedRoute accountType="admin"><Variant /></ProtectedRoute>} />

          <Route path="/admin-panel/inventario/movimientos" element={<ProtectedRoute accountType="admin"><AdminMotion /></ProtectedRoute>} />
          <Route path="/admin-panel/inventario/movimientos/nuevo" element={<ProtectedRoute accountType="admin"><Motion /></ProtectedRoute>} />
          <Route path="/admin-panel/inventario/movimientos/:id" element={<ProtectedRoute accountType="admin"><MotionDetail /></ProtectedRoute>} />

          <Route path="/admin-panel/promociones" element={<ProtectedRoute accountType="admin"><AdminPromotion /></ProtectedRoute>} />
          <Route path="/admin-panel/promociones/nueva" element={<ProtectedRoute accountType="admin"><Promotion /></ProtectedRoute>} />

          <Route path="/admin-panel/registro/documento" element={<ProtectedRoute accountType="admin"><NewInvoice /></ProtectedRoute>} />
          <Route path="/admin-panel/reporte/documento" element={<ProtectedRoute accountType="admin"><AdminInvoice /></ProtectedRoute>} />
          <Route path="/admin-panel/compras/registro" element={<ProtectedRoute accountType="admin"><RegisterPurchase /></ProtectedRoute>} />

          <Route path="/admin-panel/factura/:id" element={<ProtectedRoute accountType="admin"><Invoice /></ProtectedRoute>} />
          <Route path="/admin-panel/nota-credito/:id" element={<ProtectedRoute accountType="admin"><Invoice /></ProtectedRoute>} />
          <Route path="/admin-panel/nota-debito/:id" element={<ProtectedRoute accountType="admin"><Invoice /></ProtectedRoute>} />
          <Route path="/admin-panel/guia-remision/:id" element={<ProtectedRoute accountType="admin"><Invoice /></ProtectedRoute>} />
          <Route path="/admin-panel/retencion/:id" element={<ProtectedRoute accountType="admin"><Invoice /></ProtectedRoute>} />
          <Route path="/admin-panel/compra/:id" element={<ProtectedRoute accountType="admin"><Invoice /></ProtectedRoute>} />

          <Route path="/admin-panel/admin-cuentas" element={<ProtectedRoute accountType="admin"><AdminAccounts /></ProtectedRoute>} />
          <Route path="/admin-panel/admin-cuentas/libro-diario" element={<ProtectedRoute accountType="admin"><DailyBook /></ProtectedRoute>} />

          <Route path="/admin-panel/bancos" element={<ProtectedRoute accountType="admin"><AdminBank /></ProtectedRoute>} />
          <Route path="/admin-panel/bancos/nuevo" element={<ProtectedRoute accountType="admin"><Bank /></ProtectedRoute>} />

          <Route path="/admin-panel/pagos/:id" element={<ProtectedRoute accountType="admin"><Payment /></ProtectedRoute>} />

          <Route path="/admin-panel/ecommerce" element={<ProtectedRoute accountType="admin"><AdminEcommerce /></ProtectedRoute>} />
          <Route path="/admin-panel/ecommerce/:ticket" element={<ProtectedRoute accountType="admin"><Ecommerce /></ProtectedRoute>} />

          <Route path="/admin-panel/estadisticas" element={<ProtectedRoute accountType="admin"><AdminStatistics /></ProtectedRoute>} />
        </Routes>
      </AppLayout>
    </Router>
  );
};

export default App;